/*
 *  Geo Tools
 *    Provides common tools and funcitons for geo related items, including
 *    callbacks etc.
 *
 *  Dependencies:
 *    js-cookie - Cookies is used to cache data.
 *
 *  Version:
 *    1.0.0 - 2020/10/13
 */

import Cookies from 'js-cookie';

let CACHE_GEO_DATA;
let IS_FETCHING = false;
let HAS_ERRORED = false;

export const GEO_LISTENERS = [];
export const GEO_CACHE_COOKIE = 'GeoDataCache';

export const geoIsFetching = () => IS_FETCHING && !HAS_ERRORED;

export const fetchGeo = (callback) => {
  //Have we already fetched?
  if(CACHE_GEO_DATA) return callback(CACHE_GEO_DATA);
  GEO_LISTENERS.push(callback);

  //Are we already fetching?
  if(IS_FETCHING) return;

  //Check cookies
  try {
    CACHE_GEO_DATA = Cookies.get(GEO_CACHE_COOKIE);
    if(typeof CACHE_GEO_DATA === "string") CACHE_GEO_DATA = JSON.parse(CACHE_GEO_DATA);
  } catch(e) {
    console.error('Failed to parse GeoData, not a huge issue', e);
    CACHE_GEO_DATA = null;
  }

  if(CACHE_GEO_DATA) return callback(CACHE_GEO_DATA);

  //Fetch from Third Party
  IS_FETCHING = true;
  $.ajax({
    url: 'https://ipapi.co/json/',
    data: {
      key: 'XwGGJLIxdJ5ussHhOC510iqRIviCedcCugYeTFEgq6XcsEpgSA'
    },
    method: "GET",
    dataType: 'json',
    success: data => {
      //Trigger our listeners and cache
      CACHE_GEO_DATA = data;
      IS_FETCHING = false;
      try {
        Cookies.set(GEO_CACHE_COOKIE, JSON.stringify(data), { expires: 1 });
      } catch(e) {
        console.error('Failed to cache geo data, not a major issue', e);
      }
      GEO_LISTENERS.forEach(gl => gl(data));
      $(document).trigger('onGeo', data);
    },

    error: (...args) => {
      HAS_ERRORED = true;
      //Err.
      console.error(`Failed to fetch geo data`);
      console.error(...args);
    }
  })
}

export const onGeoFetch = (data) => {
  if(Cookies && Cookies.get(GEO_CACHE_COOKIE)) return fetchCountry();
}

export const fetchCountry = () => {
  // make country code lowercase, is coming in as lower case from tag
  try {
    let geoData = JSON.parse(Cookies.get(GEO_CACHE_COOKIE));
    if (!geoData) return null;
    let geoCountry = geoData.country_code.toLowerCase();
    return geoCountry;
  } catch(e) {
    console.error(e);
    return null;
  }
}


export const addInternationalMsgClass = (geoCountry) => {
   if (!geoCountry) return;

   //if it's outside of au
   if(geoCountry != 'au') {
    if (!$('html,body').hasClass('is-international')) {
      $('html,body').addClass('is-international');
    }
  }
}